exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-editor.vs\t\t.snippet-placeholder { background-color: rgba(10, 50, 100, 0.1); }\n.monaco-editor.vs-dark\t.snippet-placeholder { background-color: rgba(124, 124, 124, 0.1); }\n.monaco-editor.hc-black\t.snippet-placeholder { background-color: rgba(124, 124, 124, 0.1); }\n\n.monaco-editor.vs\t\t.finish-snippet-placeholder { outline: rgba(10, 50, 100, 0.5) solid 1px; }\n.monaco-editor.vs-dark\t.finish-snippet-placeholder\t{ outline: #525252 solid 1px; }\n.monaco-editor.hc-black\t.finish-snippet-placeholder\t{ outline: #525252 solid 1px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./submodules/vscode/src/vs/editor/contrib/snippet/browser/snippetSession.css
// module id = 625
// module chunks = 0